import * as React from 'react';
import {
    Checkbox as MuiCheckbox,
    CheckboxProps as MuiCheckboxProps,
    PaletteColor,
    useTheme,
} from '@mui/material';
import {
    checkboxCheckedIcon,
    checkboxUncheckedIcon,
    checkboxIndeterminateIcon,
} from '@europrocurement/l2d-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type CheckboxProps = MuiCheckboxProps;

export const Checkbox: React.FunctionComponent<CheckboxProps> = function (props: CheckboxProps) {
    const { color = 'primary' } = props;
    const { palette } = useTheme();
    const paletteColor: PaletteColor =
        (palette[color as keyof typeof palette] as PaletteColor) || palette.primary;

    const isLightMode = palette.mode === 'light';
    const uncheckedColor = isLightMode ? palette.grey[400] : palette.grey[600];
    const checkedBgColor = isLightMode ? paletteColor.main : paletteColor.main;
    const checkedIconColor = palette.getContrastText(checkedBgColor);

    const icon = checkboxUncheckedIcon.props.option ? (
        <FontAwesomeIcon
            icon={checkboxUncheckedIcon.props.option}
            color={uncheckedColor}
            size="lg"
        />
    ) : null;

    const checkedIcon = checkboxCheckedIcon.props.option ? (
        <FontAwesomeIcon
            icon={checkboxCheckedIcon.props.icon}
            color={checkedIconColor}
            size="lg"
        />
    ) : null;

    const indeterminateIcon = (
        <FontAwesomeIcon
            icon={checkboxIndeterminateIcon.props.icon}
            color={checkedIconColor}
            size="lg"
        />
    );

    return (
        <MuiCheckbox
            {...props}
            data-testid="checkbox"
            icon={icon}
            checkedIcon={checkedIcon}
            indeterminateIcon={indeterminateIcon}
        />
    );
};
